module.exports = __webpack_public_path__ + "img/user-default.d362c3b9.svg";